var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAddressBook = function SvgIconAddressBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.25 4v16h13V4zm-2 14.625v1.625c0 .966.784 1.75 1.75 1.75h13.5a1.75 1.75 0 0 0 1.75-1.75V3.75A1.75 1.75 0 0 0 19.5 2H6a1.75 1.75 0 0 0-1.75 1.75v1.625H3a1 1 0 0 0 0 2h1.25v1.75H3a1 1 0 0 0 0 2h1.25v1.75H3a1 1 0 1 0 0 2h1.25v1.75H3a1 1 0 1 0 0 2zm8.5-9.75a2 2 0 1 0 0 4 2 2 0 0 0 0-4m2.956 4.695a4 4 0 1 0-5.911 0 6.6 6.6 0 0 0-1.903 1.425 1 1 0 0 0 1.466 1.36 4.626 4.626 0 0 1 6.784 0 1 1 0 1 0 1.466-1.36 6.6 6.6 0 0 0-1.902-1.425",
    clipRule: "evenodd"
  })));
};
export default SvgIconAddressBook;